import init from '../../../js/init';

const name = 'navbar';
const selector = '.navbar';
const itemsSelector = `${selector} ${selector}__item`;

init(Drupal, name, selector, root => {
  const sectionIds = root.querySelectorAll(itemsSelector);
  sectionIds.forEach(function(sectionId){
    sectionId.addEventListener('click', function (e) {
      e.preventDefault();
      const navbarHeight = root.clientHeight;
      const container = e.target.getAttribute('href').replace('#', '');
      const containerOffset = document.getElementById(container).offsetTop;
      const containerHeight = document.getElementById(container).clientHeight;
      const newCenter = containerOffset + (containerHeight / 2);
      const actualScrollTo = newCenter - (window.innerHeight / 2) + navbarHeight;
      window.scrollTo({
        top: actualScrollTo,
        behavior: 'smooth',
      });
    });
  });

  document.addEventListener('scroll', function () {
    sectionIds.forEach(function(sectionId){
      const container = sectionId.getAttribute('href').replace('#', '');
      const containerOffset = document.getElementById(container).offsetTop;
      const containerHeight = document.getElementById(container).clientHeight;
      const containerBottom = containerOffset + containerHeight;
      const scrollPosition = document.scrollingElement.scrollTop;
      const viewCenter = scrollPosition + (window.innerHeight / 2);
      if(viewCenter < containerBottom && viewCenter > containerOffset){
        sectionId.classList.add('font-bold');
        sectionId.classList.add('underline');
      } else {
        sectionId.classList.remove('font-bold')
        sectionId.classList.remove('underline')
      }
    });
  });
});
